import { DateTimeHelper } from "src/app/core/helper/datetime.helper";

export class Guest {
    displayName: string;
    name: string;
    contact: string;
    userId: number;
    accessLevel: number;
    isEmailVerified: boolean;
    lastActive: string;
    phone: string;
    ticketCount: number;
    avatar: string;
    bidCount: number;
    bidTotal: number;

    lastActiveFmt: string;

    email: string;
    inviteStatus: number;

    constructor(guest?: Partial<Guest>) {
        Object.assign(this, guest);

        if (this.lastActive != null) {
            this.lastActiveFmt = DateTimeHelper.formatDate(this.lastActive);
        } else {
            this.lastActiveFmt = '-';
        }
    }


}